module.exports = __webpack_public_path__ + "img/equipos_varios.80f7fef5.jpg";